"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const NumericInputWrapper = styled_components_1.default.div({
    display: 'flex',
    alignItems: 'center',
});
const NumericInputLabel = styled_components_1.default.label((0, util_theme_sxc_1.sx2CssThemeFn)({
    mr: 'auto',
    fontSize: [2, 3],
}));
const NumericControlWrap = styled_components_1.default.div(({ theme }) => theme.inputs.numericControlWrap);
const NumericControl = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    variant: 'iconBtn',
})(({ theme }) => theme.inputs.numericControl);
const NumericInput = props => {
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const { minValue = Number.MIN_VALUE, maxValue = Number.MAX_VALUE, value, incrementDisabled, label, onChange, className, testId, } = props;
    const onDecrement = () => onChange(value - 1);
    const onIncrement = () => onChange(value + 1);
    const handleOnChange = (e) => {
        const nextValue = parseInt(e.target.value, 10);
        if (nextValue <= minValue || nextValue >= maxValue)
            return;
        onChange(nextValue);
    };
    return (react_1.default.createElement(NumericInputWrapper, { className: className, "data-id": testId },
        react_1.default.createElement(NumericInputLabel, { className: "numeric-input-label" }, label),
        react_1.default.createElement(NumericControlWrap, null,
            react_1.default.createElement(NumericControl, { disabled: minValue > value - 1, icon: { name: 'minus' }, onClick: onDecrement, "data-id": `${testId}_dec`, className: "decrease-button" }, t('numericInput.decrease')),
            react_1.default.createElement("input", { className: "input", value: value, onChange: handleOnChange, min: minValue, max: maxValue, readOnly: true, "data-id": `${testId}_input` }),
            react_1.default.createElement(NumericControl, { disabled: incrementDisabled || maxValue < value + 1, icon: { name: 'plus' }, onClick: onIncrement, "data-id": `${testId}_inc`, className: "increment-button" }, t('numericInput.increase')))));
};
exports.default = NumericInput;
//# sourceMappingURL=NumericInput.js.map